
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alliance",
      function () {
        return require("private-next-pages/alliance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alliance"])
      });
    }
  